module.exports = __webpack_public_path__ + "img/fudai_tuijain_chanpin_btn.eb5a42e9.png";